var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLqty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.691 8.735c.024 10.095 6.084 10.316 11.743 10.05 1.405-.066 2.619.055 3.668.314a9.598 9.598 0 0 0 .517-3.116 9.613 9.613 0 0 0-9.613-9.613 9.576 9.576 0 0 0-6.313 2.365zm.152-3.031A11.928 11.928 0 0 1 14.004 4c6.62 0 11.984 5.365 11.984 11.984 0 1.373-.23 2.692-.656 3.92C29.997 22.317 30 27.983 30 27.983H14.242c-.124 0-.247-.002-.37-.005.08-.002.16-.005.239-.009H13.94c-11.92 0-16.624-15.68-6.096-22.288l-.002.024z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLqty);
export default __webpack_public_path__ + "static/media/LQTY.b35791c99ee1302bb1ac61ed9bc366a4.svg";
export { ForwardRef as ReactComponent };